(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const button = document.querySelector('.faq-button');
    if (button) {
      button.addEventListener('click', function() {
        const faqMenuHolder = document.querySelector('.faq-menu-holder');
        if (faqMenuHolder) {
          faqMenuHolder.classList.toggle('visually-hidden');
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
